<div *ngIf="successMessage" class="alert alert-success" role="alert">
	<mat-icon>thumb_up</mat-icon> &nbsp;
	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{successMessage}}
	</span>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">

	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{errorMessage}}
	</span>
</div>

<div class="row_1">
	<div class="top_grid_agg">
		<div class="row justify-content-center">
			<div class="content">
				<div style="width: 50%; justify-content: left; display: flex;">
					<button routerLink="/newtask" class="back_button col-sm-1">BACK</button>
				</div>
				<div style="width: 50%; justify-content: right; display: flex;">
					<button class="add_button col-sm-1 float-right" (click)="addtask()">CREATE</button>
				</div>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="left-grid">
				<div class="period-form">
					<form class="form-horizontal hr">
						<div class="form-group">
							<!-- <div class="period-row">
							<label class="control-label col-sm-5">Period:</label>
							<div class="col-sm-7">
								<select [(ngModel)]="selected_period" [ngModelOptions]="{standalone: true}">
									<option *ngFor="let period of periodData" [value]="period.periodId">
										{{period.name}} {{period.year}}
									</option>
								</select>
							</div>
						</div> -->
							<div class="region-row" style="margin-bottom: 25px;">
								<label class="control-label col-sm-5">Region:
									<span style="color:#ff0000">*</span>
								</label>
								<div class="col-sm-7">
									<!-- <p-multiSelect class="multi-select" [showTransitionOptions]="'0ms'"
								[hideTransitionOptions]="'0ms'" [options]="selectedRegions" optionLabel="label"
								[virtualScroll]="true" itemSize="30" autoWidth="false"
								[style]="{'width':'242px', 'height':'25px'}" [(ngModel)]="selectedRegion"
								[ngModelOptions]="{standalone: true}">
							</p-multiSelect> -->
									<mat-form-field appearance="outline" class="fixed-select">
										<mat-select [(ngModel)]="selected_region" name="region" [multiple]="true"
											placeholder="Select Region(s)">

											<!-- Sticky Select All with Search Row -->
											<mat-option disabled>
												<div
													style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
													<!-- Real checkbox -->
													<mat-checkbox [checked]="isAllSelected()"
														[indeterminate]="isIndeterminate()"
														(change)="toggleSelectAll($event)" style="margin-right: 8px;">
													</mat-checkbox>

													<!-- Search box -->
													<ngx-mat-select-search [formControl]="regionFilterCtrl"
														placeholderLabel="Search" noEntriesFoundLabel="No regions found"
														style="flex: 1;">
													</ngx-mat-select-search>
												</div>
											</mat-option>
											<div style="max-height: 200px; overflow-y: auto;">

												<!-- Options -->
												<mat-option *ngFor="let user of filteredRegions | async" [value]="user">
													{{ user.label }}
												</mat-option>
											</div>
										</mat-select>
									</mat-form-field>
								</div>
							</div>
							<div class="contingency-row">
								<label class="control-label col-sm-5">Contingency Date:
									<span style="color:#ff0000">*</span>
								</label>
								<div class="col-sm-7">
									<input type="date" id="contingency-date" [(ngModel)]="selectedDate"
										[ngModelOptions]="{standalone: true}">
								</div>
							</div>
						</div>
					</form>
					<div class="card1-footer d-flex justify-content-end ">
						<button class="add_button" (click)="onaddRow()">ADD</button>
						<button class="reset_button" style="margin-left: 30px;" (click)="reset()">RESET</button>
					</div>

				</div>
			</div>

			<div style="padding:0px 10px 10px 10px" class="right-grid">

				<div class="period-row">
					<label class="periodLabel control-label col-sm-2">Period:
						<span style="color:#ff0000">*</span>
					</label>
					<div class="periodDrpDwn col-sm-10">
						<select [(ngModel)]="selected_period" [ngModelOptions]="{standalone: true}">
							<option *ngFor="let period of periodData" [value]="period.periodId">
								{{period.name}} {{period.year}}
							</option>
						</select>
					</div>
				</div>

				<ag-grid-angular #agGrid style="height: 431px;font-family: Roboto;" id="contingency-table"
					[theme]="'legacy'" class="ag-theme-balham" [columnDefs]="columnDefs" [rowData]="rowData"
					(gridReady)="onGridReady($event)" [context]="context" [enableCellTextSelection]="true"
					[ensureDomOrder]="true"></ag-grid-angular>

			</div>
		</div>
	</div>
</div><br />